type StorageType = 'localStorage' | 'sessionStorage';

interface StorageItem {
  key: string;
  value: any;
  storageType?: StorageType; // Defaults to 'localStorage' if not provided
}

const setStorageItems = (items: StorageItem[]): void => {
  items.forEach(({ key, value, storageType = 'localStorage' }) => {
    const storage = storageType === 'localStorage' ? localStorage : sessionStorage;
    storage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
  });
};

export default setStorageItems;
